import { useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import '../../App.css';
import Alerta from '../../components/Alerta/Alerta';
import AlertaConfirmacao from '../../components/AlertaConfirmacao/AlertaConfirmacao';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import FormPadrao from '../../components/FormPadrao/FormPadrao';
import Pagina from '../../components/Pagina/Pagina';
import Tabela from '../../components/Tabela/Tabela';
import api from '../../services/api';
import './OP.css';

function ListarOPs() {
  const navigate = useNavigate();
  const [OPs, setOPs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchBar, setSearchBar] = useState('');

  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: false });
  const [alertStatus, setAlertStatus] = useState('success');
  const {
    isOpen: isOpenExcluir,
    onOpen: onOpenExcluir,
    onClose: onCloseExcluir,
  } = useDisclosure({
    defaultIsOpen: false,
  });
  const [alertTitle, setAlertTitle] = useState('');
  const [message, setMessage] = useState('');
  const [selectedItem, setSelectedItem] = useState('');

  useEffect(() => {
    async function GetOPs() {
      let payload = {
        database: localStorage.getItem('database'),
        data: '{}',
      };
      let res = await api.post('/ListOrdensProducao/Get', payload);
      if (res.status === 200) {
        let data = res.data;
        data.Ordens.forEach(b => {
          b.Selecionado = false;
        });
        setOPs(data.Ordens);
        setLoading(false);
      } else {
        alert('Erro ao buscar dados');
      }
    }
    GetOPs();
  }, []);

  function handleEdit(item) {
    navigate(`/OrdensProducao/Editar/${item.Id}`);
  }

  function handleClick() {
    navigate('/OrdensProducao/Editar');
  }

  function handleDelete(item) {
    setSelectedItem(item.Id);
    setAlertTitle('Excluir');
    setMessage('Deseja excluir a ordem de produção?');
    onOpenExcluir();
  }

  let deleteItem = async () => {
    let payload = {
      data: selectedItem,
      database: localStorage.getItem('database'),
    };
    let res = await api.post('/ListOrdensProducao/Delete', payload);
    let data = res.data;
    onCloseExcluir();
    if (data.Success) {
      setAlertStatus('success');
      setAlertTitle(data.MSG);
      onOpen();
    } else {
      setOPs(OPs.filter(item => item.Id !== selectedItem));
      setAlertStatus('error');
      setAlertTitle(data.MSG);
      onOpen();
    }
  };

  function ParseCodigo(codigo) {
    switch (codigo) {
      case 1:
        return 'Rascunho';
      case 2:
        return 'Em produção';
      case 3:
        return 'Pausada';
      case 4:
        return 'Cancelada';
      case 5:
        return 'Finalizada';
      default:
        return 'Rascunho';
    }
  }

  return (
    <>
      <AlertaConfirmacao
        isOpen={isOpenExcluir}
        onClose={onCloseExcluir}
        description={message}
        title={alertTitle}
        onConfirm={() => deleteItem()}
      />
      <Alerta
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        alertStatus={alertStatus}
        title={alertTitle}
      />
      <Pagina loading={loading}>
        <FormPadrao>
          <BarraBotoes
            botoes={[
              {
                children: 'Nova Ordem de Produção',
                onClick: handleClick,
                variant: 'turquesa',
              },
            ]}
            search={{
              placeholder: 'Procurar por ordens de produção',
              onChange: e => setSearchBar(e.target.value),
            }}
          />
          <Tabela
            titulo={'LISTAGEM DE ORDENS DE PRODUÇÃO'}
            setFunction={setOPs}
            data={OPs}
            columns={[
              {
                placeholder: 'CÓDIGO',
                name: 'Codigo',
                type: 'number',
              },
              {
                placeholder: 'STATUS',
                name: 'Status',
                type: 'function',
                function: ParseCodigo,
              },
              {
                placeholder: 'DATA DE INÍCIO',
                name: 'PrevisaoInicio',
                type: 'date',
              },
              {
                placeholder: 'PREVISÃO DE ENTREGA',
                name: 'PrevisaoEntrega',
                type: 'date',
              },
            ]}
            searchBar={searchBar}
            handleEdit={handleEdit}
            useCheck={false}
            handleDelete={handleDelete}
          />
        </FormPadrao>
      </Pagina>
    </>
  );
}

export default ListarOPs;
